import { DyTableColumn } from 'src/app/dynamic/model/dy-model';

// =====================AUTOMATION=REPORTS===================================

export const TABLE_CONFIG_COLUMNS_AR_BY_PATIENT_REPORTS: DyTableColumn[] = [
  {
    dataKey: 'patientId',
    label: 'ID',
    width: 150,
    type: 'number',
  },
  { dataKey: 'patientName', label: 'Name', width: 200, type: 'text' },
  {
    dataKey: 'dso',
    label: 'Dos',
    width: 150,
    type: 'date',
  },
  {
    dataKey: 'dueSince',
    label: 'Total A/R Age',
    width: 150,
    type: 'number',
  },
  {
    dataKey: 'netDue',
    label: 'Total Amt Due',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'duePatPortion',
    label: 'Patient Portion Due',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'dueInsPortion',
    label: 'Ins portion due',
    width: 150,
    type: 'currency',
  }
];

export const TABLE_CONFIG_COLUMNS_AR_BY_PROVIDER_REPORTS: DyTableColumn[] = [
  {
    dataKey: 'providerName',
    label: 'Provider',
    width: 200,
    type: 'text'
  },
  {
    dataKey: 'patientId',
    label: 'Pat ID',
    width: 150,
    type: 'number',
  },
  { dataKey: 'patientName', label: 'Name', width: 200, type: 'text' },
  {
    dataKey: 'dso',
    label: 'Dos',
    width: 150,
    type: 'date',
  },
  {
    dataKey: 'dueSince',
    label: 'Total A/R Age',
    width: 150,
    type: 'number',
  }
  ,
  {
    dataKey: 'netDue',
    label: 'Total Amt Due',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'duePatPortion',
    label: 'Patient Portion Due',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'dueInsPortion',
    label: 'Ins Portion Due',
    width: 150,
    type: 'currency',
  }
];


export const TABLE_CONFIG_COLUMNS_CAMPAIGN_REPORTS: DyTableColumn[] = [
  {
    dataKey: 'campaignName',
    label: 'Name',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'patientCount',
    label: 'Count Of Patients',
    width: 150,
    type: 'number',
  },
  {
    dataKey: 'totalAmount',
    label: 'Total Amount',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'totalCollectedAmount',
    label: 'Amount Recovered',
    width: 150,
    type: 'currency',
  },
];

export const TABLE_CONFIG_COLUMNS_REPORTS: DyTableColumn[] = [
  // {
  //   dataKey: 'moduleReportId',
  //   label: 'ID',
  //   width: 50,
  //   type: 'text',
  // },
  {
    dataKey: 'srno',
    label: '#',
    width: 100,
    type: 'number',
  },
  // {
  //   dataKey: 'reportSection',
  //   label: 'Report Section',
  //   width: 150,
  //   type: 'text',
  // },
  {
    dataKey: 'title',
    label: 'Report Name',
    width: 200,
    type: 'link',
  },
  {
    dataKey: 'description',
    label: 'Description',
    width: 300,
    type: 'text',
  },
  // {
  //   dataKey: 'createdOn',
  //   label: 'Created On',
  //   width: 150,
  //   type: 'text',
  // },
  // {
  //   dataKey: 'createdBy',
  //   label: 'Created By',
  //   width: 150,
  //   type: 'text',
  // },
  // {
  //   dataKey: 'isActive',
  //   label: 'Status',
  //   width: 50,
  //   type: 'status',
  // },
];

export const AR_REPORT_DATA = [
  {
    id: 1,
    reportCategory: 'A/R Aging Report',
    reportDescription: 'By Practice',
    createdOn: '07/02/2021',
    createdBy: 'Ronald Richards',
    status: 'Inactive',
  },
  {
    id: 2,
    reportCategory: 'A/R Aging Report',
    reportDescription: 'By Provider',
    createdOn: '08/02/2021',
    createdBy: 'Kristin Watson',
    status: 'Active',
  },
  {
    id: 3,
    reportCategory: 'A/R Aging Report',
    reportDescription: 'By Payor',
    createdOn: '03/03/2022',
    createdBy: 'Eleanor Pena',
    status: 'Inactive',
  },
  {
    id: 4,
    reportCategory: 'A/R Aging Report',
    reportDescription: 'By DBA/LE',
    createdOn: '07/03/2022',
    createdBy: 'Arlene McCoy',
    status: 'Active',
  },
  {
    id: 5,
    reportCategory: 'A/R Aging Report',
    reportDescription: 'By A/R Agent',
    createdOn: '07/03/2022',
    createdBy: 'Arlene McCoy',
    status: 'Active',
  },
  {
    id: 6,
    reportCategory: 'Patient Communication',
    reportDescription: 'List Of Patient Not Responding To Reminders',
    createdOn: '07/03/2022',
    createdBy: 'Cody Fisher',
    status: 'Active',
  },
  {
    id: 7,
    reportCategory: 'Patient Communication',
    reportDescription: 'List Of Patients Having A/R Dues More Than ($2,000)',
    createdOn: '06/04/2023',
    createdBy: 'Brooklyn Simmons',
    status: 'Inactive',
  },
  {
    id: 8,
    reportCategory: 'Patient Communication',
    reportDescription: 'List Of Patients having Dues By Practice location',
    createdOn: '05/04/2023',
    createdBy: 'Jane Cooper',
    status: 'Active',
  },
  {
    id: 9,
    reportCategory: 'Patient Communication',
    reportDescription: 'Remaining Scheduled Payments',
    createdOn: '05/04/2023',
    createdBy: 'Jane Cooper',
    status: 'Active',
  },
];

export const AR_AUTOMATION_REPORTS_DATA = [
  {
    id: 1,
    reportSection: 'Payments (Patients)',
    reportName: 'Type of Payment Method',
    createdOn: new Date(),
    createdBy: 'Esther Howard',
    status: 'Active',
  },
  {
    id: 2,
    reportSection: 'Payments (Patients)',
    reportName: 'Pay Now Report',
    createdOn: new Date(),
    createdBy: 'Esther Howard',
    status: 'Active',
  },
  {
    id: 3,
    reportSection: 'Payments (Patients)',
    reportName: 'Pay Now Search Report',
    createdOn: new Date(),
    createdBy: 'Esther Howard',
    status: 'Active',
  },
  {
    id: 4,
    reportSection: 'Payments (Patients)',
    reportName: 'Payment Link Report',
    createdOn: new Date(),
    createdBy: 'Esther Howard',
    status: 'Active',
  },
  {
    id: 5,
    reportSection: 'Payments (Patients)',
    reportName: 'Remote payment',
    createdOn: new Date(),
    createdBy: 'Esther Howard',
    status: 'Active',
  },
  {
    id: 6,
    reportSection: 'Payments (Patients)',
    reportName: 'Transaction History',
    createdOn: new Date(),
    createdBy: 'Ronald Richards',
    status: 'Inactive',
  },
  {
    id: 7,
    reportSection: 'Payments (Patients)',
    reportName: 'Failed Payments Report (Includes Future Failing Payments)',
    createdOn: new Date(),
    createdBy: 'Esther Howard',
    status: 'Active',
  },
  {
    id: 8,
    reportSection: 'Payment Method',
    reportName: 'List of Payment Methods like CC, ACH',
    createdOn: new Date(),
    createdBy: 'Cody Fisher',
    status: 'Active',
  },
  {
    id: 9,
    reportSection: 'Payment Plan',
    reportName: 'List of Patients with payment plan',
    createdOn: new Date(),
    createdBy: 'Brooklyn Simmons',
    status: 'Inactive',
  },
  {
    id: 10,
    reportSection: 'Payment Plan',
    reportName: 'List of Patients without payment plan',
    createdOn: new Date(),
    createdBy: 'Jacobs Jones',
    status: 'Fully Paid',
  },
  {
    id: 11,
    reportSection: 'Payment Plan',
    reportName: 'List of Patients with payment plan',
    createdOn: new Date(),
    createdBy: 'Jacobs Jones',
    status: 'Fully Paid',
  },
];

export const TABLE_CONFIG_COLUMNS_REMAINING_SCHEDULED: DyTableColumn[] = [
  {
    dataKey: 'id',
    label: 'ID',
    width: 150,
    type: 'text',
  },
  {
    dataKey: 'scheduledPeriod',
    label: 'Scheduled Period',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'transactionCount',
    label: 'Transaction Count',
    width: 150,
    type: 'number',
  },
  {
    dataKey: 'OfTotal',
    label: '% Of Total',
    width: 100,
    type: 'number',
  },
  {
    dataKey: 'amount',
    label: 'Amount',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'Total',
    label: '% Of Total',
    width: 100,
    type: 'number',
  },
];

// ======================PRACTICE=REPORTS==========================

export const TABLE_CONFIG_COLUMNS_REPORTS_LIST: DyTableColumn[] = [
  {
    dataKey: 'id',
    label: 'ID',
    width: 150,
    type: 'text',
  },
  {
    dataKey: 'reportSection',
    label: 'Report Section',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'reportName',
    label: 'Report Name',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'createdOn',
    label: 'Created On',
    width: 200,
    type: 'date',
  },
  {
    dataKey: 'createdBy',
    label: 'Created By',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'status',
    label: 'Status',
    width: 150,
    type: 'status',
  },
];

export const TABLE_CONFIG_COLUMNS_AUTOMATION_PRACTICE_REPORTS: DyTableColumn[] =
  [
    {
      dataKey: 'report',
      label: 'Report',
      width: 500,
      type: 'text',
    },
  ];

// =======================PAYMENT===============================

export const TABLE_CONFIG_COLUMNS_PAYMENT_REPORTS: DyTableColumn[] = [
  // {
  //   dataKey: 'moduleReportId',
  //   label: 'ID',
  //   width: 50,
  //   type: 'text',
  // },
  {
    dataKey: 'srno',
    label: '#',
    width: 50,
    type: 'number',
  },
  // {
  //   dataKey: 'reportSection',
  //   label: 'Report Section',
  //   width: 150,s
  //   type: 'text',
  // },
  {
    dataKey: 'title',
    label: 'Report Name',
    width: 200,
    type: 'link',
  },
  {
    dataKey: 'description',
    label: 'Description',
    width: 300,
    type: 'text',
  },
  // {
  //   dataKey: 'createdOn',
  //   label: 'Created On',
  //   width: 150,
  //   type: 'text',
  // },
  // {
  //   dataKey: 'createdBy',
  //   label: 'Created By',
  //   width: 150,
  //   type: 'text',
  // },
  // {
  //   dataKey: 'isActive',
  //   label: 'Status',
  //   width: 50,
  //   type: 'status',
  // },
];

export const TABLE_CONFIG_COLUMNS_PAYMENT_REPORTS_PAY: DyTableColumn[] = [
  {
    dataKey: 'id',
    label: 'ID',
    width: 150,
    type: 'text',
  },
  {
    dataKey: 'IPAddress',
    label: 'IP Address',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'paymentReceivedCityState',
    label: 'Payment Received City, State',
    width: 300,
    type: 'text',
  },
  {
    dataKey: 'amount',
    label: 'Amount',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'date',
    label: 'Date',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'patientName',
    label: 'Patient Name',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'patientID',
    label: 'Patient ID',
    width: 150,
    type: 'text',
  },
  {
    dataKey: 'dateOfBirth',
    label: 'Date Of Birth',
    width: 200,
    type: 'date',
  },
  {
    dataKey: 'phoneNumber',
    label: 'Phone Number',
    width: 200,
    type: 'phone',
  },
  {
    dataKey: 'paymentMethod',
    label: 'Payment Method',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'paymentType',
    label: 'Payment Type',
    width: 200,
    type: 'text',
  },
];

export const TABLE_CONFIG_COLUMNS_PAYMENT_PAY_NOW_REPORT: DyTableColumn[] = [
  // {
  //   dataKey: 'actions',
  //   label: 'Action',
  //   width: 150,
  //   type: 'action',
  //   alignClass: 'text-center',
  //   actions: [
  //     {
  //       name: 'edit',
  //       iconName: 'pencil',
  //     },
  //   ],
  // },
  {
    dataKey: 'createDate',
    label: 'Date',
    width: 200,
    type: 'date',
  },
  {
    dataKey: 'payNowLookUpTypeName',
    label: 'Lookup Type',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'patientId',
    label: 'Patient ID',
    width: 150,
    type: 'text',
    background: 'rgba(54, 154, 37, 0.1)',
    textColor: '#369A25',
  },
  {
    dataKey: 'patientName',
    label: 'Patient Name',
    width: 200,
    type: 'text',
    background: 'rgba(54, 154, 37, 0.1)',
    textColor: '#369A25',
  },
  {
    dataKey: 'phone',
    label: 'Phone Number',
    width: 200,
    type: 'phone',
    background: 'rgba(54, 154, 37, 0.1)',
    textColor: '#369A25',
  },
  {
    dataKey: 'paymentMethodName',
    label: 'Payment Method',
    width: 200,
    type: 'text',
    background: 'rgba(54, 154, 37, 0.1)',
    textColor: '#369A25',
  },
  {
    dataKey: 'amount',
    label: 'Amount',
    width: 150,
    type: 'currency',
    background: 'rgba(54, 154, 37, 0.1)',
    textColor: '#369A25',
  },
  // {
  //   dataKey: 'autoMatch',
  //   label: 'Auto Match',
  //   width: 150,
  //   type: 'text',
  // },
  {
    dataKey: 'writeBackStatusText',
    label: 'WB',
    width: 100,
    type: 'text',
  },
  {
    dataKey: 'isPatientIds',
    label: 'Patient ID',
    width: 200,
    type: 'conditionalTextLink',
    background: 'rgba(240, 60, 157, 0.1)',
    textColor: '#F03C9D',
  },
  {
    dataKey: 'pmsPatientName',
    label: 'Patient Name',
    width: 200,
    type: 'text',
    background: 'rgba(240, 60, 157, 0.1)',
    textColor: '#F03C9D',
  },
  {
    dataKey: 'pmsPhone',
    label: 'Phone Number',
    width: 200,
    type: 'phone',
    background: 'rgba(240, 60, 157, 0.1)',
    textColor: '#F03C9D',
  },
  {
    dataKey: 'pmsAmountDue',
    label: 'Amount',
    width: 150,
    type: 'currency',
    background: 'rgba(240, 60, 157, 0.1)',
    textColor: '#F03C9D',
  },
  // {
  //   dataKey: 'age',
  //   label: 'Age',
  //   width: 150,
  //   type: 'text',
  // },
  {
    dataKey: 'mapPost',
    label: 'Map & Post',
    width: 150,
    type: 'status',
  },
  {
    dataKey: 'mapStatus',
    label: 'Action',
    width: 200,
    type: 'button',
    alignClass: 'text-center',
    actions: [
      {
        name: 'mapPatient',
        isAllowedDisabled: true,
      },
    ],
  },
];

export const TABLE_CONFIG_COLUMNS_SEND_PAYMENT_LINK_REPORTS: DyTableColumn[] = [
  // {
  //   dataKey: 'transactionId',
  //   label: 'ID',
  //   width: 50,
  //   type: 'text',
  // },
  {
    dataKey: 'patientId',
    label: 'Patient Id',
    width: 150,
    type: 'text',
  },
  {
    dataKey: 'patientName',
    label: 'Patient Name',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'amount',
    label: 'Amount',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'createDate',
    label: 'Sent Mail Date',
    width: 200,
    type: 'date',
  },
  {
    dataKey: 'finalPaymentStatusName',
    label: 'Status',
    width: 150,
    type: 'status',
    tooltipDescriptionType: 'status-payment'
  },
];

export const TABLE_CONFIG_COLUMNS_TRANSACTION_HISTORY_REPORTS: DyTableColumn[] =
  [
    // {
    //   dataKey: 'transactionId',
    //   label: 'ID',
    //   width: 50,
    //   type: 'text',
    // },
    {
      dataKey: 'patientId',
      label: 'Patient Id',
      width: 150,
      type: 'text',
    },
    {
      dataKey: 'patientName',
      label: 'Patient Name',
      width: 200,
      type: 'text',
    },
    {
      dataKey: 'amount',
      label: 'Amount',
      width: 150,
      type: 'currency',
    },
    {
      dataKey: 'paymentMethod',
      label: 'How Collected',
      width: 200,
      type: 'text',
    },
    {
      dataKey: 'transactionTypesName',
      label: 'Transaction Type',
      width: 200,
      type: 'text',
    },
    {
      dataKey: 'statusValue',
      label: 'Status',
      width: 150,
      type: 'status',
    },
    {
      dataKey: 'createDate',
      label: 'Date of Payment',
      width: 200,
      type: 'date',
    },
  ];

export const TABLE_CONFIG_COLUMNS_PAYMENT_METHOD_REPORT: DyTableColumn[] = [
  {
    dataKey: 'patientID',
    label: 'Patient ID',
    width: 150,
    type: 'text',
  },
  {
    dataKey: 'patientName',
    label: 'Patient Name',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'appointmentDate',
    label: 'Appointment Date',
    width: 200,
    type: 'date',
  },
  {
    dataKey: 'procedure',
    label: 'Procedure',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'amount',
    label: 'Amount',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'paymentMethod',
    label: 'Payment Method',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'paymentType',
    label: 'Payment Type',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'paymentDate',
    label: 'Payment Date',
    width: 200,
    type: 'date',
  },
];

export const TABLE_CONFIG_COLUMNS_PAYMENT_FAILED_REPORT: DyTableColumn[] = [
  // {
  //   dataKey: 'fixIt',
  //   label: 'Fix It',
  //   width: 200,
  //   type: 'action',
  //   actions: [
  //     {
  //       name: 'fix-it',
  //       text: 'Fix It',
  //     },
  //   ],
  //   alignClass: 'text-center',
  // },
  {
    dataKey: 'fixIt',
    label: 'Fix it',
    width: 50,
    type: 'conditionalTextLink',
  },
  {
    dataKey: 'patientId',
    label: 'Patient Id',
    width: 150,
    type: 'number',
  },
  {
    dataKey: 'patientName',
    label: 'Patient Name',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'amount',
    label: 'Amount',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'createDate',
    label: 'Date of Payment',
    width: 200,
    type: 'date',
  },
  {
    dataKey: 'displayMessage',
    label: 'Failure Reason',
    width: 300,
    type: 'text',
    maxLines: 2,
  },
];

export const TABLE_CONFIG_COLUMNS_OVERALL_TRENDS_REPORT: DyTableColumn[] = [
  {
    dataKey: 'patientId',
    label: 'Patient Id',
    width: 150,
    type: 'number',
  },
  {
    dataKey: 'patientName',
    label: 'Patient Name',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'transactionCollectionTypeName',
    label: 'How Collected',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'moduleName',
    label: 'Module',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'amount',
    label: 'Amount',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'paymentCollectedDate',
    label: 'Payment Collected Date',
    width: 200,
    type: 'date',
  },
];

export const TABLE_CONFIG_COLUMNS_CC_PAYMENT_TRENDS_REPORT: DyTableColumn[] = [
  {
    dataKey: 'patientId',
    label: 'Patient Id',
    width: 150,
    type: 'number',
  },
  {
    dataKey: 'patientName',
    label: 'Patient Name',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'cardType',
    label: 'Payment Type',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'moduleName',
    label: 'Module',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'amount',
    label: 'Amount',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'paymentCollectedDate',
    label: 'Payment Collected Date',
    width: 200,
    type: 'date',
  },
];

export const TABLE_CONFIG_COLUMNS_PAYMENT_ANALYTICS_REPORT: DyTableColumn[] = [
  {
    dataKey: 'patientId',
    label: 'Patient Id',
    width: 150,
    type: 'number',
  },
  {
    dataKey: 'patientName',
    label: 'Patient Name',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'transactionTypeName',
    label: 'Form Of Payment',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'totalCount',
    label: 'Count of Payment',
    width: 150,
    type: 'number',
  },
  {
    dataKey: 'percentageOfTotalCount',
    label: '% Of Count',
    width: 150,
    type: 'percentage',
  },
  {
    dataKey: 'totalAmount',
    label: 'Total Amount',
    width: 200,
    type: 'currency',
  },
  {
    dataKey: 'percentageOfTotalAmount',
    label: '% Of Total Amount',
    width: 150,
    type: 'percentage',
  },
  {
    dataKey: 'paymentCollectedDate',
    label: 'Payment Collected Date',
    width: 200,
    type: 'date',
  },
];

// =======================SEND PAYMENT LINK REPORT===============================

export const TABLE_CONFIG_COLUMNS_PAYMENT_PLANS_REPORT: DyTableColumn[] = [
  {
    dataKey: 'paymentPlanId',
    label: 'ID',
    width: 100,
    type: 'number',
  },
  { dataKey: 'planName', label: 'Plan Name', width: 200, type: 'text' },
  {
    dataKey: 'patientId',
    label: 'Patient Id',
    width: 150,
    type: 'number',
  },
  {
    dataKey: 'patientname',
    label: 'Patient Name',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'templateName',
    label: 'Template',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'totalAmount',
    label: 'Total Amt.',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'initialAmount',
    label: 'Initial Amt.',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'paymentPlanAmount',
    label: 'Payment Plan Amt.',
    width: 200,
    type: 'currency',
  },
  {
    dataKey: 'remainingAmount',
    label: 'Remaining Amt.',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'receivedInstallmentAmount',
    label: 'Received Ins. Amt.',
    width: 200,
    type: 'currency',
  },
  // {
  //   dataKey: 'openPayment',
  //   label: 'Open Payment',
  //   width: 200,
  //   type: 'currency',
  // },
  {
    dataKey: 'installment',
    label: 'Amt. Per Ins.',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'noOfInstallments',
    label: 'Installments',
    width: 100,
    type: 'number',
  },
  {
    dataKey: 'startDate',
    label: 'Start Date',
    width: 200,
    type: 'date',
  },
  {
    dataKey: 'nextPaymentDate',
    label: 'Next Payment',
    width: 200,
    type: 'date',
  },
  {
    dataKey: 'lastPaymentDate',
    label: 'Last Payment',
    width: 200,
    type: 'date',
  },
  { dataKey: 'status', label: 'Status', width: 150, type: 'status' },
  {
    dataKey: 'isDigitalCopySavedString',
    label: 'Signed Copy',
    width: 150,
    type: 'text',
  },
];
export const TABLE_CONFIG_COLUMNS_MATCH_PATIENT: DyTableColumn[] = [
  {
    dataKey: 'patientId',
    label: 'Action',
    width: 100,
    type: 'radio',
  },
  {
    dataKey: 'patientId',
    label: 'Patient Id',
    width: 100,
    type: 'number',
  },
  { dataKey: 'patientName', label: 'Patient Name', width: 200, type: 'text' },
  {
    dataKey: 'cellPhone',
    label: 'Cell Phone',
    width: 150,
    type: 'phone',
  },
];